import { alpha } from '@mui/material/styles';

import type { OverWritable } from '../../@types/settings';

export const popover: OverWritable = {
  MuiPopover: {
    styleOverrides: {
      paper: ({ theme }) => ({
        boxShadow: theme.customShadows.z24,
        borderRadius: Number(theme.shape.borderRadius) * 1.5,
        border: `solid 1px ${alpha(theme.palette.grey[500], 0.08)}`,
      }),
    },
  },
};
